import React from "react";

import AuthForm from "../../components/Auth/AuthForm";
import PageLayout from "../../components/PageLayout";

const LoginPage: React.FC = () => {
  return (
    <PageLayout isLogin={true}>
      <AuthForm/>
    </PageLayout>
  );
};

export default LoginPage;